import { FC, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as Icons from '../icons';

type ClipboardCopyProps = {
  id?: string;
  className?: string;
  showText?: boolean;
  text: string;
};

const ClipboardCopy: FC<ClipboardCopyProps> = ({ id, className, showText, text }) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div id={id} className={`relative flex h-full items-center justify-start space-x-2 ${className ?? ''}`}>
      <CopyToClipboard text={text} onCopy={() => handleCopy()}>
        <button className={`group flex items-center ${copied ? 'cursor-default' : 'cursor-pointer'}`} onClick={e => e.preventDefault()}>
          {showText && <p className='flex-1 text-left text-xs font-bold sm:text-sm'>{text}</p>}
          <Icons.Copy className={`${!copied && 'opacity-50 group-hover:opacity-100'}`} />
          <span className={`text-green-dark !ml-[2px] text-sm underline-offset-2 ${!copied && 'group-hover:underline'}`}>
            {copied ? 'Copié !' : 'Copier'}
          </span>
        </button>
      </CopyToClipboard>
    </div>
  );
};

export default ClipboardCopy;
